import { WebPlugin } from '@capacitor/core';
export class DetectMobileServicesWeb extends WebPlugin {
    async GetMediaService() {
        return Promise.resolve({ value: "web" });
    }
    HasHMS() {
        return Promise.resolve({ value: false });
    }
    HasGMS() {
        return Promise.resolve({ value: false });
    }
}
//# sourceMappingURL=web.js.map